<template>
  <div id="login" ref="login">
    <div class="box">
      <div class="logo">
        <img src="../assets/image/login/logo.png" alt="" />
      </div>
      <div>欢迎登录</div>
      <div>{{$systemTitle}}</div>
      <div class="login_box">
        <div>用 户 登 录</div>
        <div style="margin-top: 1.5rem">
          <el-input
            placeholder="请输入登录ID"
            prefix-icon="el-icon-user"
            v-model="userName"
          >
          </el-input>
        </div>
        <div style="margin-top: 1.5rem">
          <el-input
            placeholder="请输入密码"
            prefix-icon="el-icon-lock"
            v-model="passWord"
            show-password
          >
          </el-input>
          <div class="checkbox">
            <el-checkbox v-model="remember">记住密码</el-checkbox>
          </div>
          <div class="login_btn">
            <el-button type="primary" @click="login">登 录</el-button>
          </div>
        </div>
      </div>
      <div>您的设备分辨率为： {{screenWidth}} {{screenHeight}}
      </div>
    </div>
  </div>
</template>

<script>
import { Encrypt } from "@/utils/secret";

export default {
  data() {
    return {
      clientHeight: "0",
      // userName: "主管",
      // passWord: "jykj88",
      userName: "",
      passWord: "",
      remember: false,
      isFullscreen: false,
      screenWidth: undefined,     // 屏幕宽
      screenHeight: undefined,
      constHospitalList : []

    };
  },
  created() {

    if (localStorage.getItem("userName") && localStorage.getItem("pwd")) {
      this.userName = localStorage.getItem("userName");
      this.passWord = localStorage.getItem("pwd");
      this.remember = true;
    } else {
      this.userName = "";
      this.passWord = "";
      this.remember = false;
    }

  },
  mounted() {
    this.screenWidth = document.documentElement.clientWidth;   // 屏幕宽
    this.screenHeight = document.documentElement.clientHeight;
  },
  methods: {
    login() {
      let data = {
        loginName: this.userName,
        loginPwd: Encrypt(this.passWord)
      };
      const requestData = {
        url: process.env.BASE_API + "/login",
        method: "post",
        data
      };
      this.$axios(requestData).then(res => {
        this.constHospitalList.push({ID:-1, RegionName: "深圳市宝安区妇幼保健院"});
        this.constHospitalList.push({ID:-2, RegionName: "中国医学科学院阜外医院深圳医院"});
        this.constHospitalList.push({ID:-3, RegionName: "深圳市宝安区纯中医治疗医院"});

        let resData = res.data;
        localStorage.setItem("userName", this.userName);
        if (this.remember) {
          localStorage.setItem("pwd", this.passWord);
        }
        if (resData.isAdmin == 1) {
          let data = JSON.stringify(resData.hospitalList.concat(this.constHospitalList));
          localStorage.setItem("hospitalList", data);
          localStorage.setItem("isAdmin", resData.isAdmin);
          this.$router.push("/screen1");
        } else if (resData.isAdmin == 0) {
          localStorage.setItem("isAdmin", resData.isAdmin);
          this.$router.push({
            path: "/screen2",
            query: {
              hospitalID: resData.hospitalList[0].ID,
              RegionName: resData.hospitalList[0].RegionName
            }
          });
        } else {
          return;
        }
      });
    }
    // changeFixed(clientHeight) {
    //   // 动态修改样式
    //   this.$refs.login.style.height = clientHeight + "px";
    // }
  },
  watch: {
    // 监听屏幕高度
    // clientHeight() {
    //   this.changeFixed(this.clientHeight);
    // }
  }
};
</script>

<style lang="less" scoped>
#login {
  width: 100%;
  height: 100%;
  position: relative;
  background: url("../assets/image/login/login_bg.png") no-repeat;
  background-size: 100% 100%;

  .box {
    padding-top: 6%;
    text-align: center;
    color: #00cdff;
    font-size: 2rem;
    .logo {

      > img {
        width: 20%;
        height: 30%;
      }
    }

    > div {
      color: #00cdff;
      font-size: 2rem;
    }

    .login_box {
      padding: 1rem 7rem;
      margin-top: 3rem;
      margin-left: 50%;
      transform: translateX(-50%);
      width: 35%;
      height: 21rem;
      background: url("../assets/image/login/login_box.png") no-repeat;
      background-size: 100% 100%;
      > div:nth-child(1) {
        font-size: 1.2rem;
      }

      /deep/ .el-input {
        caret-color: #fff;
      }

      /deep/ .el-input__inner {
        height: 2rem;
        line-height: 2rem;
        color: rgba(255, 255, 255, 1);
        font-size: 1.2rem;
        padding: 0 3rem;
        border: 1px solid rgba(11, 161, 248, 0.2);
        background-color: rgba(11, 161, 248, 0.2);
      }

      /deep/ .el-input__icon {
        width: 3rem;
        color: #00e1eb;
        font-size: 1.2rem;
      }

      .checkbox {
        text-align: left;
        margin-top: 1rem;

        /deep/ .el-checkbox__label {
          font-size: 1.2rem;
        }

        /deep/ .el-checkbox__inner {
          width: 1.4rem;
          height: 1.4rem;
          border: 1px solid rgba(11, 161, 248, 0.2);
          background-color: rgba(11, 161, 248, 0.2);
        }

        /deep/ .el-checkbox__input {
          line-height: 1.8rem;
        }

        /deep/ .el-checkbox__inner::after {
          left: 7px;
          height: 12px;
        }

        /deep/ .el-checkbox {
          color: rgba(255, 255, 255, 0.6);
        }
      }

      .login_btn {
        margin-top: 1rem;

        /deep/ .el-button {
          width: 100%;
          height: 3rem;
          font-size: 1.4rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/login.vue